import { useState, useEffect } from "react";
import "./notificationCalendar.css";
import {
  compareAsc,
  format,
  getDay,
  getMonth,
  getYear,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
} from "date-fns";
import { currentDate, setDays, weekdays } from "./dataCalendar";
import playLeft from "../../picture/play-left.png";
import playRight from "../../picture/play-right.png";
import playLeftGreen from "../../picture/play-left-green.png";
import playRightGreen from "../../picture/play-right-green.png";
import whiteBell from "../../picture/whiteBell.png";

const NotificationCalendar = ({
  selectedDate,
  setSelectedDate,
  selectedDates,
  setSelectedDates,
  notificationsList,
  currentNotification,
  calendarDays,
  setCalendarDays,
  currentActive,
  isEditing,
  setSelectedAlarms,
  selectedAlarms,
}) => {
  const months = [
    "JANUAR",
    "FEBRUAR",
    "MART",
    "APRIL",
    "MAJ",
    "JUN",
    "JUL",
    "AVGUST",
    "SEPTEMBAR",
    "OKTOBAR",
    "NOVEMBAR",
    "DECEMBAR",
  ];
  const [daysCalendar, setDaysCalendar] = useState([]);
  const [selected, setSelected] = useState(selectedDate);

  const renderEmpty = (cond) => {
    const index = cond
      ? getDay(daysCalendar[0])
      : 6 - getDay(daysCalendar[daysCalendar.length - 1]);
    if (index === 0) return;
    let array = Array.from({ length: index });
    return array.map((_, index) => {
      return <div className="calendar-notification-day" key={index}></div>;
    });
  };

  const handlePrevMonth = (e) => {
    let newDate;
    if (getMonth(selected) - 1 === -1)
      newDate = new Date(`${getYear(selected) - 1}-12-1`);
    else {
      newDate = new Date(
        `${getYear(selected)}-${
          getMonth(selected) - 1 !== 0 ? getMonth(selected) : "1"
        }-1`
      );
    }
    const nextMonth = document.querySelector(".notification-arrow-right-img");
    nextMonth.src = `${playRight}`;
    const prevMonth = document.querySelector(".notification-arrow-left-img");

    prevMonth.src = `${playLeftGreen}`;

    //newDate.setHours(0, 0, 0, 0);
    setSelected(newDate);
    setDaysCalendar(setDays(newDate));
  };

  const handleSelectedDate = (daySelect) => {
    if (compareAsc(daySelect, new Date().setHours(0, 0, 0, 0)) === -1) return;
    if (!isEditing && currentActive === 2 && notificationsList.length > 1) {
      let isInSelectedDates = selectedDates.find(
        (date) => compareAsc(date, daySelect) === 0
      );
      if (!isInSelectedDates) return;
      let isFound = selectedAlarms.find(
        (date) => compareAsc(date, daySelect) === 0
      );
      if (isFound)
        setSelectedAlarms(
          selectedAlarms.filter((date) => compareAsc(isFound, date) !== 0)
        );
      else setSelectedAlarms([...selectedAlarms, daySelect]);
      return;
    }
    if (currentActive !== 2) {
      if (isEditing) {
        setSelected(daySelect);
        setSelectedDate(daySelect);
      } else {
        const select = selectedDates.filter(
          (day) => compareAsc(day, daySelect) === 0
        );
        let currentDates = [];
        if (select.length === 0) {
          currentDates = [...selectedDates, daySelect];
          setSelectedDates(currentDates);
        } else {
          currentDates = selectedDates.filter(
            (day) => compareAsc(day, daySelect) !== 0
          );

          setSelectedDates(currentDates);
        }
        if (currentDates.length === 0) {
          let today = new Date(new Date().setHours(0, 0, 0, 0));
          setSelected(today);
          setSelectedDate(today);
          setSelectedDates([...selectedDates, today]);
        } else {
          setSelected(currentDates[currentDates.length - 1]);
          setSelectedDate(currentDates[currentDates.length - 1]);
        }
      }
    } else {
      if (isEditing) {
        let firstNotification = new Date(
          new Date(currentNotification.date).setHours(0, 0, 0, 0)
        );
        if (compareAsc(firstNotification, daySelect) === -1) return;
        const select = selectedDates.filter(
          (day) => compareAsc(day, daySelect) === 0
        );
        let currentDates = [];

        if (select.length === 0) {
          currentDates = [...selectedDates, daySelect];
          setSelectedDates(currentDates);
        } else {
          currentDates = selectedDates.filter(
            (day) => compareAsc(day, daySelect) !== 0
          );
          setSelectedDates(currentDates);
        }
        if (currentDates.length === 0) {
          let today = new Date(new Date().setHours(0, 0, 0, 0));
          setSelected(today);
          setSelectedDate(today);
          setSelectedDates([...selectedDates, today]);
        } else {
          setSelected(currentDates[currentDates.length - 1]);
          setSelectedDate(currentDates[currentDates.length - 1]);
        }
      } else {
        if (notificationsList.length < 2) {
          let firstNotification = new Date(
            new Date(notificationsList[0].date).setHours(0, 0, 0, 0)
          );

          if (compareAsc(firstNotification, daySelect) === -1) return;

          const select = selectedDates.filter(
            (day) => compareAsc(day, daySelect) === 0
          );
          let currentDates = [];

          if (select.length === 0) {
            currentDates = [...selectedDates, daySelect];
            setSelectedDates(currentDates);
          } else {
            currentDates = selectedDates.filter(
              (day) => compareAsc(day, daySelect) !== 0
            );
            setSelectedDates(currentDates);
          }
          if (currentDates.length === 0) {
            let today = new Date(new Date().setHours(0, 0, 0, 0));
            setSelected(today);
            setSelectedDate(today);
            setSelectedDates([...selectedDates, today]);
          } else {
            setSelected(currentDates[currentDates.length - 1]);
            setSelectedDate(currentDates[currentDates.length - 1]);
          }
        }
      }
    }
  };

  const handleCompareActive = (day) => {
    let isInDates = false;
    if (isEditing) {
      if (currentActive === 2 && currentNotification.alarms.length === 0) {
        let firstNotification = new Date(
          new Date(currentNotification.date).setHours(0, 0, 0, 0)
        );
        selectedDates.forEach((date) => {
          if (
            compareAsc(new Date(new Date(date).setHours(0, 0, 0, 0)), day) ===
              0 &&
            (compareAsc(day, firstNotification) === -1 ||
              compareAsc(day, firstNotification) === 0)
          ) {
            isInDates = true;
          }
        });
      } else if (
        currentActive === 2 &&
        currentNotification.alarms.length !== 0
      ) {
        selectedDates.forEach((date) => {
          if (
            compareAsc(new Date(new Date(date).setHours(0, 0, 0, 0)), day) === 0
          ) {
            isInDates = true;
          }
        });
      } else {
        if (selectedDate.length > 1) {
          selectedDates.forEach((date) => {
            if (
              compareAsc(new Date(new Date(date).setHours(0, 0, 0, 0)), day) ===
              0
            ) {
              isInDates = true;
            }
          });
        } else {
          if (
            compareAsc(
              new Date(new Date(selectedDate).setHours(0, 0, 0, 0)),
              day
            ) === 0
          ) {
            isInDates = true;
          }
        }
      }
    } else {
      if (currentActive === 2 && notificationsList.length > 1) {
        /*let firstNotification = new Date(
          new Date(notificationsList[0].date).setHours(0, 0, 0, 0)
        );
        for (let i = 1; i < notificationsList.length; i++) {
          let currentNotification = new Date(
            new Date(notificationsList[i].date).setHours(0, 0, 0, 0)
          );
          if (compareAsc(currentNotification, firstNotification) === -1) {
            firstNotification = currentNotification;
          }
        }

        if (compareAsc(day, firstNotification) === 0) isInDates = true;*/
        let foundAlarm = selectedAlarms.find(
          (selected) => compareAsc(selected, day) === 0
        );
        if (foundAlarm) isInDates = true;
      } else {
        if (currentActive === 2 && notificationsList.length === 1) {
          let firstNotification = new Date(
            new Date(notificationsList[0].date).setHours(0, 0, 0, 0)
          );
          selectedDates.forEach((date) => {
            if (
              compareAsc(new Date(new Date(date).setHours(0, 0, 0, 0)), day) ===
                0 &&
              (compareAsc(day, firstNotification) === -1 ||
                compareAsc(day, firstNotification) === 0)
            ) {
              isInDates = true;
            }
          });
        } else {
          if (currentActive === 2) {
            selectedDates.forEach((date) => {
              if (
                compareAsc(
                  new Date(new Date(date).setHours(0, 0, 0, 0)),
                  day
                ) === 0
              ) {
                isInDates = true;
              }
            });
          }
          if (currentActive === 1 || currentActive === 5) {
            if (isEditing) {
              notificationsList.forEach((notification) => {
                if (
                  compareAsc(
                    new Date(new Date(notification.date).setHours(0, 0, 0, 0)),
                    day
                  ) === 0
                ) {
                  isInDates = true;
                }
              });
            } else {
              selectedDates.forEach((date) => {
                if (
                  compareAsc(
                    new Date(new Date(date).setHours(0, 0, 0, 0)),
                    day
                  ) === 0
                ) {
                  isInDates = true;
                }
              });
            }
          }
        }
      }
    }
    return isInDates;
  };

  const handleCompareNotification = (day) => {
    if (currentActive !== 2) return;
    let date,
      isInDates = false;
    notificationsList.forEach((notification) => {
      date = new Date(new Date(notification.date).setHours(0, 0, 0, 0));

      if (compareAsc(day, date) === 0) isInDates = true;
    });

    return isInDates;
  };

  const handleNextMonth = (e) => {
    let newDate;
    if (getMonth(selected) + 1 === 12)
      newDate = new Date(`${getYear(selected) + 1}-1-1`);
    else {
      newDate = new Date(`${getYear(selected)}-${getMonth(selected) + 2}-1`);
    }
    //newDate.setHours(0, 0, 0, 0);
    const previousMonth = document.querySelector(
      ".notification-arrow-left-img"
    );
    const nextMonth = document.querySelector(".notification-arrow-right-img");
    previousMonth.src = `${playLeft}`;

    nextMonth.src = `${playRightGreen}`;

    setSelected(newDate);
    setDaysCalendar(setDays(newDate));
  };

  const setDays = (selected) => {
    const startDay = startOfMonth(selected);
    const endDay = endOfMonth(selected);

    return eachDayOfInterval({
      start: startDay,
      end: endDay,
    });
  };

  useEffect(() => {
    setDaysCalendar(setDays(selectedDate));
  }, [selectedDate]);

  return (
    <div className="notification-calendar-wrapper">
      {currentActive !== 2 && (
        <div className="notification-change-time change-down">
          <div className="notification-arrow-left" onClick={handlePrevMonth}>
            <img
              className="notification-arrow-left-img"
              src={playLeft}
              alt=""
            />
          </div>
          <div className="notification-text-day">
            {months[getMonth(selected)]}
          </div>
          <div className="notification-arrow-right" onClick={handleNextMonth}>
            <img
              className="notification-arrow-right-img"
              src={playRight}
              alt=""
            />
          </div>
        </div>
      )}
      <div className="event-notification-calendar-filter">
        <div className="calendar-notification-filter">
          <div className="calendar-wrapper-notification">
            {weekdays.map((day) => {
              return (
                <div className="calendar-notification-header" key={day}>
                  {day}
                </div>
              );
            })}
            {daysCalendar.length !== 0 && renderEmpty(true)}
            {daysCalendar.length !== 0 &&
              daysCalendar.map((day, index) => {
                return (
                  <div
                    className={
                      handleCompareActive(day)
                        ? "calendar-notification-day active"
                        : "calendar-notification-day"
                    }
                    key={index}
                    onClick={() => handleSelectedDate(day)}
                  >
                    <span>{format(day, "d")}</span>
                    {handleCompareNotification(day) && (
                      <img src={whiteBell} alt="" />
                    )}
                  </div>
                );
              })}
            {renderEmpty(false)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCalendar;
